import { render, staticRenderFns } from "./rich-text-tool.vue?vue&type=template&id=e4808326&"
import script from "./rich-text-tool.vue?vue&type=script&lang=js&"
export * from "./rich-text-tool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports